import { Controller } from 'stimulus';
import {overrideLinkTargets} from "../../public/common";

export default class extends Controller {
  static targets = ['expandableBlockHeader', 'customerContent', 'notFoundMessage'];

  initialize() {
    if (this.expandableBlockHeaderTargets?.length) {
      this.openDetailsIfAny();
    }

    if (this.hasCustomerContentTarget) {
      overrideLinkTargets({
        $containerEl: this.customerContentTarget
      });
    }

    if (this.hasNotFoundMessageTarget) {
      this.redirectIfNotFound();
    }
  }

  redirectIfNotFound() {
    const {notFoundMessageTarget} = this;
    const message = notFoundMessageTarget.dataset.altMessage;
    const redirectUri = notFoundMessageTarget.dataset.redirectUri;
    const setMessage = (sec) => {
      this.notFoundMessageTarget.innerText = message.replace(/%s/g, sec);
    }

    if (message) {
      let count = 5;

      const timer = setInterval(() => {
        if (count <= 1) {
          clearInterval(timer);
          window.location = redirectUri;
        } else {
          count -= 1;
          setMessage(count)
        }
      }, 1000);

      this.notFoundMessageTarget.classList.add('alert', 'alert-info', 'text-start');
      setMessage(count);
    }
  }

  openDetailsIfAny() {
    const hash = window.location.hash;
    if (hash) {
      const $header = this.expandableBlockHeaderTargets.find(item => item.getAttribute('aria-controls') === hash.substring(1));
      const $content = $header?.nextElementSibling;

      if ($header && $content) {
        const headerOffset = 80;

        $content.classList.add('show');

        $header.classList.remove('collapsed');
        $header.setAttribute('aria-expanded', true);

        // scroll to the $header element with some headerOffset to avoid overlapping with the sticky header
        // emulated by $nextTick
        setTimeout(() => {
          window.scrollTo({
            top: $header.getBoundingClientRect().top + window.scrollY - headerOffset,
            behavior: 'smooth'
          });
        }, 1);
      }
    }
  }
}
